import React from 'react';
import PropTypes from 'prop-types';
import {NavLink as Link} from 'react-router-dom';

const renderItem = (item, onClickItem) => {
  if (item.get('path')) {
    return (
      <Link to={item.get('path')} onClick={onClickItem} className='item' itemProp='item name'>
        {item.get('title')}
      </Link>
    );
  }

  return <span itemProp='item name'>{item.get('title')}</span>;
};

function Breadcrumbs (props) {
  const { items, onClickItem } = props;

  return (
    <div className='breadcrumbs' itemScope itemType='http://schema.org/BreadcrumbList'>
      {
        items.map((item, id) => {
          return (
            <span key={id} itemProp='itemListElement' itemScope itemType='http://schema.org/ListItem'>
              {id !== 0 && <span className='slash'> / </span>}
              {renderItem(item, onClickItem)}
              <meta itemProp='position' content={id + 1} />
            </span>
          );
        })
      }
    </div>
  );
}

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        path: PropTypes.string
      })
  ),
  onClickItem: PropTypes.func
};

Breadcrumbs.defaultProps = {
  items: [],
  onClick: () => {}
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/ui/Breadcrumbs/index.jsx